export { DemoTemplate } from './DemoTemplate';
export { default as BlogPostTemplate } from './BlogPostTemplate/BlogPostTemplate';
export { default as LandingPageTemplate } from './LandingPageTemplate/LandingPageTemplate';
export { default as TemplateSwitch } from './TemplateSwitch/TemplateSwitch';
export { default as TemplateWrapper } from './TemplateWrapper/TemplateWrapper';
export { default as UseCaseTemplate } from './UseCaseTemplate/UseCaseTemplate';
export { default as PartnerDirectoryTemplate } from './PartnerDirectoryTemplate/PartnerDirectoryTemplate';
export { default as PartnerPageTemplate } from './PartnerPageTemplate/PartnerPageTemplate';
export { default as ProductPageTemplate } from './ProductPageTemplate/ProductPageTemplate';
export { default as EventPageTemplate } from './EventPageTemplate/EventPageTemplate';
export { default as HubTemplate } from './HubTemplate/HubTemplate';
export { default as ArticleTemplate } from './Resources/ArticleTemplate/ArticleTemplate';
export { default as CoastTemplate } from './CoastTemplate/CoastTemplate';
export { default as TopicPageTemplate } from './Resources/TopicPageTemplate/TopicPageTemplate';
export { default as ResourcesSearchTemplate } from './Resources/ResourcesSearchTemplate';
export * from './InstitutionTemplate';
export {
  MainTemplate,
  mainTemplateMetaTagAdapter,
  mainTemplateNavigationAdapter,
  mainTemplateStylesAdapter,
  homepageMetadataAdapter,
} from './MainTemplate';
